import { render, staticRenderFns } from "./AttachmentInput.vue?vue&type=template&id=05a9496e&scoped=true&"
import script from "./AttachmentInput.vue?vue&type=script&lang=js&"
export * from "./AttachmentInput.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentInput.vue?vue&type=style&index=0&id=05a9496e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a9496e",
  null
  
)

export default component.exports